<div class="container d-flex align-items-center p-5" *ngIf="isLoading">
    <mat-spinner [diameter]="60" [strokeWidth]="3" class="mx-auto"></mat-spinner>
</div>
<div class="container p-5" *ngIf = "!isLoading" [formGroup]="customDomainForm">
    <h1 class="mb-0">Custom domain</h1>
    <mat-accordion>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <mat-icon>looks_one</mat-icon>
                </mat-panel-title>
                <mat-panel-description> Add your domain </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="row">
                <mat-form-field appearance="outline" class="w-100 mb-3">
                    <mat-label>Add your domain</mat-label>
                    <mat-error>You need to enter a domain</mat-error>
                    <input [readonly] = "customDomainStatus?.verificationStatus == 'verified'" matInput placeholder="www.happy.com" required formControlName="domainName">
                </mat-form-field>
            </div>
            <mat-action-row>
                <button mat-raised-button (click)="createDomain()" >Send</button>
            </mat-action-row>
        </mat-expansion-panel>
        <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <mat-icon>looks_two</mat-icon>
                </mat-panel-title>
                <mat-panel-description>
                    Set up domain
                </mat-panel-description>
            </mat-expansion-panel-header>
            <p>
                Add an ANAME or ALIAS record pointing to
                <b>{{frontEndHost}}</b>

                If your DNS provider does not support ANAME or ALIAS records, use an A record pointing to
                <b>{{frontEndIp}}</b>
            </p>
            <p>
                Add a CNAME record for www pointing to
                <b>{{frontEndHost}}</b>
            </p>
            <mat-action-row *ngIf = "customDomainStatus?.verificationStatus == 'verified'">
                <button mat-raised-button color="warn" mat-button (click)= "deleteDomain()">Delete</button>
                <button mat-raised-button disabled class="domain-verified-domain" mat-button>Verified</button>
            </mat-action-row>

            <mat-action-row *ngIf = "!(customDomainStatus?.verificationStatus == 'verified')">
                <button *ngIf = "!(customDomainStatus?.verificationStatus == 'verified')" (click)= "fetchCustomDomainStatus()"  mat-button>Verify</button>
            </mat-action-row>
        </mat-expansion-panel>
    </mat-accordion>
    <p class="text-danger text-center p-5" *ngIf="errorMessage">{{errorMessage}}</p>
</div>